Controller.$inject = [];

function Controller() {}

export function HuiSpinner() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            variant: '@',
            sizing: '@',
            color: '@'
        },
        controller: Controller,
        controllerAs: '$huiSpinnerCtrl',
        transclude: {
            content: '?spinnerContent',
            message: '?spinnerMessage'
        },
        template: ($element, $attrs) => {
            return `
        <div class="hui hui-spinner d-flex flex-column align-items-center gap-2" 
             ng-class="[
               'hui-' + ($huiSpinnerCtrl.color || 'primary'),
               $huiSpinnerCtrl.variant || 'default',
               $huiSpinnerCtrl.sizing || 'md'
             ]">
          <div class="spinner-wrapper">
            <div ng-class="{
                'spin': $huiSpinnerCtrl.variant === 'default' || !$huiSpinnerCtrl.variant,
                'circle': $huiSpinnerCtrl.variant === 'waves'
             }">
               <div ng-if="$huiSpinnerCtrl.variant === 'default' || !$huiSpinnerCtrl.variant" class="tip"></div>
            </div>
           
            <div ng-if="$huiSpinnerCtrl.variant === 'waves'" class="ring ring-3"></div>
            <div ng-if="$huiSpinnerCtrl.variant === 'waves'" class="ring ring-2"></div>
            <div ng-if="$huiSpinnerCtrl.variant === 'waves'" class="ring ring-1"></div>
          
            <ng-transclude ng-transclude-slot="content"></ng-transclude>
          </div>
          <ng-transclude ng-transclude-slot="message"></ng-transclude>
        </div>
      `;
        }
    };
}